export interface StoreCartLine {
  type: "product" | "group";
  id: number;
  productIds: number[];
  name: string;
}

const CART_KEY = "vinci-store-cart";

export function readStoreCart(): StoreCartLine[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(CART_KEY) || "[]");
    if (!Array.isArray(value)) return [];
    return value.filter((line): line is StoreCartLine =>
      line && (line.type === "product" || line.type === "group") &&
      Number.isInteger(line.id) && line.id > 0 && Array.isArray(line.productIds) &&
      line.productIds.length > 0 && line.productIds.every((id: unknown) => typeof id === "number" && Number.isInteger(id) && id > 0) &&
      typeof line.name === "string",
    );
  } catch {
    return [];
  }
}

export function writeStoreCart(lines: StoreCartLine[]) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(lines));
  } catch {
    // The in-memory cart remains usable if browser storage is unavailable.
  }
}
